import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AddProject from "./Add_project";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../api";
import Loader from "./Loader";  // Assuming you have a Loader component
import Skeleton from "react-loading-skeleton"; // Import Skeleton

const ProjectComp = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id } = useParams();
    const [formData, setFormData] = useState({
        status: "",
        agent: "",
    });

    const authToken = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");

    const axiosInstance = axios.create({
        headers: {
            authorization: `Bearer ${authToken}`,
            user_id: userId,
        },
    });


    const fetchProjects = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/project?status=${formData.status}&agent=${formData.agent}`, {
                headers: {
                    authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    user_id: localStorage.getItem("userId"),
                },
            });
            setProjects(response.data);
            setLoading(false); // Set loading to false once data is fetched
        } catch (error) {
            console.error("Error fetching Project:", error);
            if (error.response?.status === 429) {
                // Handle Too Many Requests
                Swal.fire("Error", "Too many login attempts. Please try again later.", "error");
                window.location.href = "/"; // Redirect to the login page
                return;
            }
            if (error.response?.status === 401) {
                // Unauthorized error
                Swal.fire("Session Expired", "Please log in again.", "warning").then(() => {
                    localStorage.removeItem("authToken"); // Clear auth token
                    localStorage.removeItem("userId"); // Clear user ID
                    window.location.href = "/"; // Redirect to login page
                });
            } else {
                // Other errors
                Swal.fire("Error", "Failed to fetch Project. Please try again.", "error");
            }
            setLoading(false); // Set loading to false in case of error
        }
    };

    const handleInputChange = (selectedOption, actionMeta) => {
        setFormData((prevData) => ({
            ...prevData,
            [actionMeta.name]: selectedOption ? selectedOption.value : '',
        }));
    };

    useEffect(() => {
        fetchProjects();
    }, [formData]);


    // Fetch Project from the API on mount
    useEffect(() => {
        fetchProjects();
    }, []);

    const handleDeleteClick = (projectId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance
                    .delete(`${API_BASE_URL}/api/project/${projectId}`)
                    .then(() => {
                        Swal.fire("Deleted!", "The project has been deleted.", "success");
                        setProjects((prevProjects) =>
                            prevProjects.filter((project) => project.id !== projectId)
                        );
                        window.location.reload();
                    })
                    .catch((error) => {
                        console.error("Error deleting project:", error);
                        Swal.fire("Error!", "There was an issue deleting the project.", "error");
                    });
            } else {
                Swal.fire("Cancelled", "The project was not deleted.", "info");
            }
        });
    };

    const handleIconClick = (project_id) => {
        const project = projects.find((proj) => proj.id === project_id);
        if (project) {
            console.log("Project ID:", project_id);
            console.log(project);
        } else {
            console.error("Project not found for ID:", project_id);
        }
    };

    const toCamelCase = (str) => {
        const camelCased = str.replace(/_([a-z])/g, (match, group1) => group1.toUpperCase());
        return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
    };


    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    useEffect(() => {
        setCurrentPage(1);
    }, [search, itemsPerPage]);

    const filteredData = projects.filter((project) =>
        [
            project.client.full_name,
            project.project_name,
            project.start_date,
            project.end_date,
            (project.lastbill != null ? project.lastbill.end_date : "NONE"),
            project.amount,
            project.status,
            project.renewal_month,
            project.package,
            project.remarks,
        ]
            .filter(Boolean) // Prevent errors from null values
            .some((field) => field.toString().toLowerCase().includes(search))
    );

    const formatINR = (amount) => {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 2,
        }).format(amount);
    };

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, startIndex + parseInt(itemsPerPage));
    // console.log(startIndex);
    // console.log(startIndex + parseInt(itemsPerPage));

    return (
        <div className="content">
            {/* Show Loader when loading */}
            {loading ? (

                <div className="skeleton-loader-table">
                    <table className="table table-bordered dataTable" id="datatable">
                        <thead>
                            <tr>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                                <th><div className="skeleton-loader"></div></th>
                            </tr>
                        </thead>
                    </table>
                </div>
            ) : (
                <>
                    <div className="d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="row">

                            <div className="col-md-3 mb-3">
                                <label className="form-label">Agent</label>
                                <select
                                    name="agent"
                                    value={formData.agent}
                                    onChange={(e) => setFormData({ ...formData, agent: e.target.value })}
                                    className="form-select"
                                >
                                    <option value="">Select Agent</option>
                                    <option value="MEET">Meet</option>
                                    <option value="BRIJESH">Brijesh</option>
                                    <option value="NISHANTSIR">Nishant Sir</option>
                                    <option value="CHIRAG">Chirag</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-3">
                                <label className="form-label">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                    className="form-select"
                                >
                                    <option value="">Select Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                    <option value="onhold">On Hold</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Content when not loading */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2 text-start">
                            <div className="pagetitle">
                                <h1>Project</h1>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="#">Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">Project</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <button
                            className="btn btn-primary d-flex align-items-center"
                            data-bs-toggle="modal"
                            data-bs-target="#add_project"
                        >
                            <i className="fa fa-plus-circle me-2"></i>Add Project
                        </button>
                    </div>


                    <div className="table-responsive custom-datatable-filter">
                        <div className="row mt-2 justify-content-between mb-3">
                            <div className="d-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
                                <label htmlFor="dt-length-0"> entries per page</label>
                                <select aria-controls="datatable" className="form-select form-select-sm" id="dt-length-0" value={itemsPerPage}
                                    onChange={(e) => setItemsPerPage(e.target.value)}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="d-md-flex justify-content-between align-items-center dt-layout-end col-md-auto ms-auto">
                                <label htmlFor="dt-search-0" className="form-label me-2 visually-hidden">Search:</label>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className="p-2 border rounded mb-4 w-full"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>
                        <table className="table table-bordered dataTable" id="datatable">
                            <thead>
                                <tr>
                                    <th>Action</th>
                                    <th>S.No</th>
                                    <th>Agent</th>
                                    <th>Client</th>
                                    <th>Project Name</th>
                                    {/* <th>Start Date</th> */}
                                    {/* <th>End Date</th> */}
                                    <th>Due Date</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Renewal</th>
                                    <th>Package</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.map((project, index) => (
                                    <tr key={project.id}>
                                        <td>
                                            {/* <i
                className="fa fa-inr text-danger ms-3"
                data-bs-toggle="modal"
                data-bs-target="#add_project_ledger"
                style={{ cursor: "pointer" }}
                onClick={() => handleIconClick(project.id)}
            ></i> */}
                                            <Link to={`/dashboard/view-project/${project.id}`} title="View">
                                                <i className="fas fa-eye text-success ms-3"></i>
                                            </Link>
                                            <Link to={`/dashboard/edit-project/${project.id}`} title="Edit">
                                                <i className="fas fa-edit text-primary ms-3"></i>
                                            </Link>
                                            <i
                                                className="fas fa-trash text-danger ms-3"
                                                title="Delete"
                                                onClick={() => handleDeleteClick(project.id)}
                                                style={{ cursor: "pointer" }}
                                            ></i>
                                        </td>
                                        <td> {((currentPage - 1) * itemsPerPage) + (index + 1)}</td>
                                        <td>
                                            <span className={`badge ${project.agent === 'MEET' ? 'bg-primary' : project.agent === 'BRIJESH' ? 'bg-success' : project.agent === 'NISHANTSIR' ? 'bg-warning' : 'bg-info'}`}>
                                                {project.agent}
                                            </span>
                                        </td>
                                        <td>{toCamelCase(project.client.full_name)}</td>
                                        <td>{toCamelCase(project.project_name)}</td>
                                        {/* <td>{project.start_date}</td> */}
                                        {/* <td>{project.end_date}</td> */}
                                        <td>{(project.lastbill != null
                                            ? project.lastbill.end_date < moment().add(1, 'months').format("YYYY-MM-DD") && project.lastbill.renewal_month > 0
                                                ? project.lastbill.end_date < moment().format("YYYY-MM-DD")
                                                    ? (<span className={`badge bg-inactive`}>{project.lastbill.end_date}</span>)
                                                    :
                                                    (<span className={`badge bg-upcoming`}>{project.lastbill.end_date}</span>)
                                                : project.lastbill.end_date
                                            : "")}
                                        </td>
                                        <td>{formatINR(project.amount)}</td>
                                        <td>
                                            <span
                                                className={`badge ${project.status === "pending"
                                                    ? "badge-warning"
                                                    : project.status === "active"
                                                        ? "badge-success"
                                                        : project.status === "inactive"
                                                            ? "badge-secondary"
                                                            : "badge-info"
                                                    }`}
                                            >
                                                {toCamelCase(project.status)}
                                            </span>
                                        </td>
                                        <td>{project.renewal_month} M</td>
                                        <td>{project.package}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="flex justify-center mt-4">
                            <button
                                className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                Prev
                            </button>
                            <span className="px-3 py-1">Page {currentPage} of {totalPages}</span>
                            <button
                                className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>

                    </div>

                    {/* Modals */}
                    <AddProject />
                </>
            )}
        </div>
    );
};

export default ProjectComp;
